


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { vote } from '@/api/api';
import { Loading } from 'vant';
import qs from 'qs';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Loading);
@Component
export default class Cloundbtn extends Vue {
  @Prop() canVote: boolean = true;
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop({ default: false }) voteWeChat!: boolean;
  @Prop({ default: 10 }) MaxNum!: number;
  @Prop({ default: -1 }) voteIndex!: number;
  @Prop({ default: 0 }) source!: string;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;

  showSlideVerify = false;
  pointOut = false;
  unionId!: string | null;
  loading: boolean = false;
  showDialog = false;
  dialogTitle = '友情提示';
  dialogContent = '请在上游新闻App进行投票';
  throttleTimer: any = null;
  voteEnable = true;
  actspan: boolean = true;
  votetimelist: any = {
    //投票时间
    voteysstr: 1688598000000, //2023-07-06 07:00:00
    // voteysend: 1689156000000, //2023-07-12 18:00:00
    voteysend: 1689177600000, //2023-07-13 00:00:00
    votecsstr: 1690214400000, //2023-07-25 00:00:00
    votecsend: 1691337600000, //2023-08-07 00:00:00
    votejsstr: 1691510400000, //2023-08-09 00:00:00
    votejsend: 1692720000000, //2023-08-23 00:00:00
  };
  mounted() {
    this.getvotetime();
  }
  @Watch('canVote', { immediate: true })
  getvotetime() {
    const nowtime = parseInt(new Date().getTime() + '');
    if (
      parseInt(this.votetimelist.voteysstr) < nowtime &&
      parseInt(this.votetimelist.voteysend) > nowtime
    ) {
      this.canVote = false;
    }
    if (
      parseInt(this.votetimelist.votecsstr) < nowtime &&
      parseInt(this.votetimelist.votecsend) > nowtime
    ) {
      this.canVote = false;
    }
    if (
      parseInt(this.votetimelist.votejsstr) < nowtime &&
      parseInt(this.votetimelist.votejsend) > nowtime
    ) {
      this.canVote = false;
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx536e2bb3e4f6664f';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  notVote() {
    Toast('投票已结束');
    return;
  }
  async onVote() {
    this.actspan = false;
    setTimeout(() => {
      this.actspan = true;
    }, 1000);
    // DONE 大量代码需重构
    // 微信环境中引导用户登录(若需要)
    if (!isWeiXin()) {
      Toast('请在微信客户端访问');
      return;
    }
    if (
      this.voteWeChat &&
      isWeiXin() &&
      !window.localStorage.getItem('unionid')
    ) {
      this.$dialog
        .confirm({
          title: '微信登录',
          message: '点赞前需要进行微信登录',
        })
        .then(() => {
          console.log('确定');
          this.WechatLogin();
          this.loading = false;
        })
        .catch(() => {
          console.log('取消');
          this.loading = false;
        });
      return;
    }

    // 开始投票，微信环境和App环境传递参数有所不同
    let apiData: any = {};
    if (this.voteWeChat && isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      apiData = {
        id: this.voteId,
        unionid: this.unionId,
        source: this.source,
      };
    } else if (window.udid) {
      apiData = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
        source: this.source,
      };
    } else {
      Toast('请在微信客户端访问');
      return;
    }
    //  else {
    //   this.$dialog
    //     .confirm({
    //       title: '友情提示',
    //       message: '请在上游新闻App进行投票',
    //       confirmButtonText: '还没装？一步安装',
    //       cancelButtonText: '我已安装过',
    //       closeOnClickOverlay: true,
    //     })
    //     .then((action) => {
    //       console.log(action);
    //       window.location.href = this.downLoadUrl;
    //     })
    //     .catch((action) => {
    //       console.log(action);
    //       if (action === 'overlay') {
    //         // 忽略掉点击遮罩层的关闭行为
    //         return;
    //       }
    //       if (isWeiXin()) {
    //         this.pointOut = true;
    //       } else {
    //         window.location.href =
    //           'shangyounews://{"dt":"7","url":"' +
    //           document.location.href +
    //           '"}';
    //       }
    //     });
    //   return;
    // }
    // 节流
    if (!this.voteEnable) {
      return Toast('手速不要太快哦');
    }
    this.voteEnable = false;
    clearTimeout(this.throttleTimer);
    this.throttleTimer = setTimeout(() => {
      this.voteEnable = true;
    }, 3000);

    const result = await vote(this.voteName, apiData);
    this.successVote(result);
  }
  fSlideData(res: any) {
    this.showSlideVerify = false;
    if (this.voteWeChat && isWeiXin()) {
      const data = {
        id: this.voteId,
        unionid: this.unionId,
        source: this.source,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    } else if (window.udid) {
      const data = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
        source: this.source,
      };
      const lastData = Object.assign(res, data);
      vote(this.voteName, lastData).then((result: any) =>
        this.successVote(result),
      );
    }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        this.$emit('votSuccess', res.data, this.voteIndex);
        break;
      // case 201:
      //   // 需要滑动验证
      //   this.showSlideVerify = true;
      //   break;
      // case 202:
      //   if (parseFloat(window.version) >= 4.5) {
      //     // 需要在App内登录
      //     window.handleMessage('{"action":"mUserLogin","data":""}');
      //   } else {
      //     // 老版本唤起App登录页面栈
      //     window.location.href = 'client:logout';
      //   }
      //   break;
      case 203:
        // 超出投票规定次数
        // if (this.voteWeChat && isWeiXin()) {
        //   this.$dialog
        //     .confirm({
        //       title: '友情提示',
        //       message: `投票次数已满，打开上游新闻app可再获得${this.MaxNum}次投票机会`,
        //       confirmButtonText: '还没装？一步安装',
        //       cancelButtonText: '我已安装过',
        //       closeOnClickOverlay: true,
        //     })
        //     .then(() => {
        //       window.location.href = this.downLoadUrl;
        //     })
        //     .catch((action) => {
        //       if (action === 'overlay') {
        //         // 忽略掉点击遮罩层的关闭行为
        //         return;
        //       }
        //       if (isWeiXin() === true) {
        //         this.pointOut = true;
        //       } else {
        //         window.location.href =
        //           'shangyounews://{"dt":"7","url":"' +
        //           document.location.href +
        //           '"}';
        //       }
        //     });
        // } else {
        Toast.fail(res.msg);
        // }
        break;
      case 505:
        localStorage.removeItem('unionid');
        window.location.reload();
        break;
      case 500:
      case 204:
      case 300:
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
